import React from 'react';
import { YES, NO } from '../modules/constants';

/**
 * This component is purely for presentation and doesn't actually do anything
 * the entire interaction is controlled through css.
 * Place in the dom tree directly under a checkbox, use
 * css to hide the checkbox and the toggle will reflect the
 * checkbox state. If you wish for the toggle to be clickable
 * include it and the checkbox inside of a label.
 *
 * @function
 * @constructor
 */
function Toggle() {
    return (
        <i className='toggle'>
            <span>{YES.toLowerCase()}</span>
            <span>{NO.toLowerCase()}</span>
        </i>
    );
}
export { Toggle };
